import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "button"]

  connect() {
    this.closeOnClickOutside = this.closeOnClickOutside.bind(this)
    this.closeOnEscape = this.closeOnEscape.bind(this)
    this.updatePosition = this.updatePosition.bind(this)
  }

  toggle(event) {
    event.stopPropagation()
    
    if (this.menuTarget.classList.contains("hidden")) {
      this.show()
    } else {
      this.hide()
    }
  }

  show() {
    // Close any other open dropdowns first
    document.querySelectorAll('[data-controller="dropdown"] [data-dropdown-target="menu"]').forEach(menu => {
      if (menu !== this.menuTarget) {
        menu.classList.add("hidden")
      }
    })
    
    this.menuTarget.classList.remove("hidden")
    this.updatePosition()
    
    document.addEventListener("click", this.closeOnClickOutside)
    document.addEventListener("keydown", this.closeOnEscape)
    window.addEventListener("scroll", this.updatePosition, true)
    window.addEventListener("resize", this.updatePosition)
  }

  hide() {
    this.menuTarget.classList.add("hidden")
    document.removeEventListener("click", this.closeOnClickOutside)
    document.removeEventListener("keydown", this.closeOnEscape)
    window.removeEventListener("scroll", this.updatePosition, true)
    window.removeEventListener("resize", this.updatePosition)
  }

  updatePosition() {
    const button = this.buttonTarget
    const menu = this.menuTarget
    const rect = button.getBoundingClientRect()
    
    // Position menu below button, aligned to the right
    menu.style.position = "fixed"
    menu.style.top = `${rect.bottom + 4}px`
    menu.style.right = `${window.innerWidth - rect.right}px`
    menu.style.left = "auto"
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hide()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.hide()
    }
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnClickOutside)
    document.removeEventListener("keydown", this.closeOnEscape)
    window.removeEventListener("scroll", this.updatePosition, true)
    window.removeEventListener("resize", this.updatePosition)
  }
}
